import styled from 'styled-components'

import Footnote from 'components/Typography/Footnote'
import { style } from 'theme'

export const MobileOnlyFootnote = styled(Footnote)`
  text-align: center;
  padding-top: 20px;

  @media screen and (min-width: ${style(theme => theme.breakpoints.sm + 1)}px) {
    display: none;
  }
`

export const StyledHeroHeader = styled.div`
  font-size: 22px;
  line-height 30px;
  margin: 30px auto 40px;
  text-align: center;
  max-width: 400px;
  font-weight: bold;
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    max-width: 340px;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    margin: 0px auto 30px;
  }
`

export const FooterContainer = styled.div`
  font-size: 12px;
  line-height 16px;
  margin: 20px auto 0;
  text-align: center;
  max-width: 400px;
  color: ${style(theme => theme.colors.stone)};
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    display: none;
  }
`

export const CityField = styled.div`
  padding-bottom: 20px;
  width: 100%;

  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    width: calc(75% - 20px);
    margin-right: 20px;
  }
`

export const StateField = styled.div`
  width: 100%;
  padding-bottom: 20px;

  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    width: 25%;
  }
`
